// Fuente única de verdad para la versión de la aplicación
// Actualizar aquí cuando se haga un release
export const APP_VERSION = '3.33.5';
